import { provideGlobalConfig } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { createApp, type Component } from 'vue';

// ⚠ .vue 单文件组件在 TS 眼里是 any(vue-tsc 才认得它)。
//   在边界上收成 Component,免得 any 顺着 createApp 扩散出去
import AppRaw from './App.vue';
import { installLocationChangeEvents } from './lib/location-events';

const App = AppRaw as Component;
import 'element-plus/es/components/alert/style/css';
import 'element-plus/es/components/button/style/css';
import 'element-plus/es/components/checkbox/style/css';
import 'element-plus/es/components/date-picker/style/css';
import 'element-plus/es/components/dialog/style/css';
import 'element-plus/es/components/drawer/style/css';
import 'element-plus/es/components/dropdown/style/css';
import 'element-plus/es/components/empty/style/css';
import 'element-plus/es/components/form/style/css';
import 'element-plus/es/components/icon/style/css';
import 'element-plus/es/components/input/style/css';
import 'element-plus/es/components/input-number/style/css';
import 'element-plus/es/components/loading/style/css';
import 'element-plus/es/components/progress/style/css';
import 'element-plus/es/components/segmented/style/css';
import 'element-plus/es/components/select/style/css';
import 'element-plus/es/components/table/style/css';
import 'element-plus/es/components/tag/style/css';
import 'element-plus/es/components/upload/style/css';
import './styles.css';
import './assets/styles/amt-admin.css';
import './business-workspace.css';
import './workspace-design.css';
import './pages/sales-workbench.css';
import './desktop-workspace.css';

installLocationChangeEvents();

const app = createApp(App);
provideGlobalConfig({ locale: zhCn }, app, true);
app.mount('#app');
